import { render } from "./follow_card.vue?vue&type=template&id=218b3816"
import script from "./follow_card.js?vue&type=script&lang=js&external"
export * from "./follow_card.js?vue&type=script&lang=js&external"

import "./follow_card.vue?vue&type=style&index=0&id=218b3816&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__